ACC.learnerconsents = {

    _autoload: [
        'bindAcceptConsentsLink',
    ],

    // eslint-disable-next-line max-len
    acceptConsents(username, password, escrowTicket, rememberMe, originalReferer, successMessage, orderGUID) {
        function onSuccess() {
            // eslint-disable-next-line max-len
            ACC.learnerlogin.signIn(username, password, rememberMe, originalReferer, successMessage, orderGUID);
        }
        $.ajax({
            type: 'POST',
            url: `${ACC.config.iamBaseUrl}/login/webacceptconsent`,
            data: { escrowTicket, client_id: ACC.config.iamClientId },
            xhrFields: {
                withCredentials: true,
            },
            success: onSuccess,
            error(jqXHR) {
                let messageKey;
                if (jqXHR.status === 404) {
                    messageKey = 'account.error.account.not.found';
                } else {
                    messageKey = 'account.error.generic';
                }
                const globalMessageRequest = {
                    globalMessages: [{
                        messageHolder: 'accErrorMsgs',
                        messages: [messageKey],
                    }],
                };
                ACC.globalmessages.createGlobalMessage(globalMessageRequest);
            },
        });
    },

    acceptMarketingConsent(username, consent) {
        $.ajax({
            type: 'POST',
            url: `${ACC.config.encodedContextPath}/login/marketing`,
            data: { username, consent },
        });
    },

    bindAcceptConsentsLink() {
        $(document).on('submit', '#acceptConsentsForm', (e) => {
            e.preventDefault();

            if ($('#marketingConsent').length) {
                ACC.learnerconsents.acceptMarketingConsent($('#username').val(), $('#marketingConsent').is(':checked'));
            }

            // eslint-disable-next-line max-len
            ACC.learnerconsents.acceptConsents($('#username').val(), '', $('#escrowTicket').val(), $('#rememberMe').is(':checked'), $('#loginReferer').val(), 'account.success.login', $('#orderCode').val());
        });
    },

    // eslint-disable-next-line max-len
    bindSsoAcceptConsentsLink(username, password, escrowTicket, rememberMe, loginReferer, successMessage, orderCode) {
        $(document).off('submit', '#acceptConsentsForm');
        $(document).on('submit', '#acceptConsentsForm', (e) => {
            e.preventDefault();

            if ($('#marketingConsent').length) {
                ACC.learnerconsents.acceptMarketingConsent(username, $('#marketingConsent').is(':checked'));
            }

            // eslint-disable-next-line max-len
            ACC.learnerconsents.acceptConsents(username, password, escrowTicket, rememberMe, loginReferer, successMessage, orderCode);
        });
    },

    showSsoAcceptConsents(loadSsoConsentModalFunction, acceptConsentFunction, username) {
        $.ajax({
            async: false,
            type: 'POST',
            url: `${ACC.config.encodedContextPath}/login/ssoacceptconsents/check`,
            data: {
                userName: username,
            },
            success: (response) => {
                if (response.showSsoAcceptConsentsFragment) {
                    loadSsoConsentModalFunction();
                } else {
                    if (response.sendMarketingConsent) {
                        ACC.learnerconsents.acceptMarketingConsent(username, true);
                    }
                    acceptConsentFunction();
                }
            },
            error: () => {
                loadSsoConsentModalFunction();
            },
        });
    },

    loadSsoAcceptConsents(username, password, escrowTicket, rememberMe, loginReferer, successMessage, orderCode) {
        const url = `${ACC.config.encodedContextPath}/login/ssoacceptconsents`;
        $('#mainPageContent').load(url, { userName: username }, () => {
            if (ACC.utils.isHedTheme()) {
                ACC.utils.addClassToBodyTag('page-upc-consents');
            }
            ACC.validation.bindFormValidation();
            // eslint-disable-next-line max-len
            ACC.learnerconsents.bindSsoAcceptConsentsLink(username, password, escrowTicket, rememberMe, loginReferer, successMessage, orderCode);
        });
    },
};
